import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { TrailerForm } from "./TrailerForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FormToolbar } from "../../common/form/FormToolbar";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { protectedEntities } from "../../../common/auth/permissions";

interface ITrailerCreateProps {}

export const TrailerEdit = (props: ITrailerCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const permissions = useActionPermissions();
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Trailer,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-trailers.title.edit">
        <TrailerForm
          toolbar={
            <FormToolbar
              showDeleteButton={
                permissions &&
                permissions[permissionNames.admin.trailers.main] &&
                permissions[permissionNames.admin.trailers.delete]
              }
            />
          }
        />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
